import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import StudentLayout from '../../layout/student/StudentLayout';
import { Backdrop, Box, Button, Card, CardContent, CircularProgress, Divider, Grid, IconButton, Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Chip from '@mui/material/Chip';
import MainCard from '../../newTestPreo/components/MainCard';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { fDate } from '../../utils2/formatTime';
import CloseIcon from '@mui/icons-material/Close';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

const CustomIcon = styled('img')({
  width: '15px',
  height: '15px',
 // position: 'fixed',
 // top: 0,
 // left: 0,
  
});

function StudentViewDemos() {
    const navigate = useNavigate()
    const studentId = localStorage.getItem('studentId');
    const enquiryId = localStorage.getItem('enquiryId');
    const enquiryPersonalDetailId = localStorage.getItem("enquiryPersonalDetailId");
    const userId = localStorage.getItem('userId');
    const [rows, setRows] = useState([])
    const [open, setOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [statusFilter, setStatusFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const [demoLoading, setDemoLoading] = useState(false);
    const [data, setData] = useState([]);

    const getStatusColor = (status) => {
      switch (status.toLowerCase()) {
        case 'pending':
          return '#FFA500'; // Orange color for pending
        case 'confirmed':
        case 'completed':
          return '#008000'; // Green color for confirmed and completed
        case 'missed':
        case 'cancelled':
          return '#FF0000'; // Red color for missed and cancelled
        default:
          return '#000000'; // Default color
      }
    };
  

    const columns = [
        { field: 'class', headerName: 'Class Name', flex: 1 },
        { field: 'test_type', headerName: 'Test Type', flex: 1 },
        { field: 'available_demo_date', headerName: 'Demo Date', flex: 1 },
        { field: 'time', headerName: 'Demo Time', flex: 1 },
        { field: 'delivery_mode', headerName: 'Delivery Mode', flex: 1 },
        { field: 'status', headerName: 'Status', flex: 1 },
        {
          field: 'action',
          headerName: 'Action',
          flex: 1,
          renderCell: (params) => (
            <Button onClick={() => handleViewDetails(params.row)}>View Details</Button> 
          ),
        },
      ];
      
      useEffect(() => {
        
        setLoading(true);
        fetch(`${API_ENDPOINT}studentdashboard/getalldemos/${enquiryPersonalDetailId}`)
        .then((response) => {
            if (!response.ok) {
              if (response.status === 403) {
                console.log('Access forbidden');
                setRows([]); 
              } else {
                navigate('/page404')
                throw new Error(`Request failed with status: ${response.status}`);
              }
            }
            return response.json();
          })
          .then((data) => {
            console.log(data);
            if (data) {
              setRows(data);
            }
          })
          .catch((error) => {
            console.error('Error fetching demos data:', error);
          })
          .finally(() => {
            setLoading(false);
          });
      }, []);

      const today = new Date();

      const flattenedData = rows.map((item) => ({
        id: item.id,
        test_type: item.test_type_id.name,
        class: item.class_id.name,
        available_demo_date: item.available_demo_date,
        time: item.slot,
        delivery_mode: item.delivery_mode,
        status: item.status,
        trainer_name: `${item.trainer_id.first_name} ${item.trainer_id.last_name}`,
        location: item.location
      }));

      const sortAndFilterDemos = () => {
        const today = new Date();
        // Reset the time part of today to 00:00:00 to only compare the date part
        today.setHours(0, 0, 0, 0);
      
        const sortedDemos = flattenedData.sort((a, b) => new Date(a.available_demo_date) - new Date(b.available_demo_date));
      
        const pastDemos = sortedDemos.filter((demo) => {
          const demoDate = new Date(demo.available_demo_date);
          demoDate.setHours(0, 0, 0, 0);
          return demoDate < today;
        });
      
        const upcomingDemos = sortedDemos.filter((demo) => {
          const demoDate = new Date(demo.available_demo_date);
          demoDate.setHours(0, 0, 0, 0);
          return demoDate >= today;
        });
      
        return { pastDemos, upcomingDemos };
      };
      
    
      const { pastDemos, upcomingDemos } = sortAndFilterDemos();


      const handleViewDetails = (row) => {
        
        setOpen(true);

        const requestData = {
          user_id: parseInt(userId),
          demo_id: row.id
        }

        const fetchData = async () => {
          try {
            setDemoLoading(true);
            const response = await fetch(`${API_ENDPOINT}route/fetchdemodetails`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                // add any other headers you need
              },
              body: JSON.stringify(requestData),
            });
    
            if (!response.ok) {
             setData([])
            }
            const result = await response.json();
            setData(result);
          } catch (error) {
            console.error("Error fetching data:", error);
            
          } finally {
            setDemoLoading(false);
          }
        };
    
        fetchData();
      };
    
      const handleClose = () => {
        setOpen(false);
        setData([])
      };

      


  return (
        <>
        <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>Fetching</Typography>
        <CircularProgress color="primary" />
      </Backdrop>
       <MainCard>
        <Box mt={2}>
        <div style={{ width: '100%' }}>
    <Typography sx={{ color: '#000000', fontFamily: '"Inters-SemiBold", Helvetica', fontSize: '20px'}} fontWeight={800}>Upcoming Demos</Typography>
    <Box m={2}/>
      {upcomingDemos.length === 0 ? (
          <Typography variant="h4" color="error">
            No upcoming demos
          </Typography>
        ) : (
              <Box>
                <Grid container spacing={4} >
                {upcomingDemos.map((classe, index) => (
             <Grid item xs ={6} lg={4}>
                <Card
                    variant="outlined"
                    sx={{
                        borderColor: 'black', // Replace 'your_border_color' with the color you want
                        borderWidth: '2px',
                        borderRadius: '30px' // Adjust the border width as needed
                    }}
                    >
            <CardContent>
            <Typography sx={{ color: '#019e6f', fontFamily: '"Inters-SemiBold", Helvetica', fontSize: '20px'}} fontWeight={800}>Demo Details</Typography>
            <Divider />
            <Box mb={2}/>
            <Grid container spacing={4}>
            <Grid item xs={12}>
                
                <Stack direction='column' spacing={2}>
               
                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/newImages/icon _Laptop_.svg" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Class Name</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.class}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/newImages/icon _Bar Chart_.svg" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Test Type</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.test_type}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/Vector (4).png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Demo Date</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{fDate(classe.available_demo_date)}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/newImages/icon _Clock_.svg" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Demo Time</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.time}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/newImages/Vector (1).svg" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Delivery Mode</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.delivery_mode}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/icons8-check-mark-32.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Status</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: getStatusColor(classe.status), fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.status}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction="row" justifyContent="space-evenly">
        {/* ... */}
        {classe.status === 'confirmed' && (
          <Box>
            {classe.delivery_mode === 'online' ? (
<Button variant="contained" color="secondary" onClick={() => handleViewDetails(classe)} >
  View Demo Link
</Button>
) : (
<Button variant="contained" color="secondary" onClick={() => handleViewDetails(classe)}>
  View Demo Location
</Button>


)}
          </Box>
        )}

{classe.status === 'completed' && (
          <>
             <Link to={`/demoevaluation/${classe?.id}`} target="_blank">
            <Button variant="contained" color="secondary">
              View My Evaluation
            </Button>
            </Link>
 <Box>
  
</Box>
</>
         
        )}
      </Stack>
                   
                    </Stack>

               
            </Grid>
            </Grid>             
            </CardContent>
     </Card>
     </Grid>
                ))}
                </Grid>
                </Box>
        )}

                <Box m={2}/>

                <Typography sx={{ color: '#000000', fontFamily: '"Inters-SemiBold", Helvetica', fontSize: '20px'}} fontWeight={800}>Past Demos</Typography>
<Box m={2}/>

{pastDemos.length === 0 ? (
          <Typography variant="h4" color="error">
            No past demos
          </Typography>
        ) : (

                <Box>
                <Grid container spacing={4} >
                {pastDemos.map((classe, index) => (
             <Grid item xs ={6} lg={4}>
                <Card
                    variant="outlined"
                    sx={{
                        borderColor: 'black', // Replace 'your_border_color' with the color you want
                        borderWidth: '2px',
                        borderRadius: '30px' // Adjust the border width as needed
                    }}
                    >
            <CardContent>
            <Typography sx={{ color: '#019e6f', fontFamily: '"Inters-SemiBold", Helvetica', fontSize: '20px'}} fontWeight={800}>Demo Details</Typography>
            <Divider />
            <Box mb={2}/>
            <Grid container spacing={4}>
            <Grid item xs={12}>
                
                <Stack direction='column' spacing={2}>
               
                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/newImages/icon _Laptop_.svg" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Class Name</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.class}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/newImages/icon _Bar Chart_.svg" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Test Type</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.test_type}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/Vector (4).png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Demo Date</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{fDate(classe.available_demo_date)}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/newImages/icon _Clock_.svg" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Demo Time</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.time}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/newImages/Vector (1).svg" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Delivery Mode</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.delivery_mode}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                      <Box display='flex' >
                    <CustomIcon src="/icons8-check-mark-32.png" alt="School Icon" />
                    <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Status</Typography>
                    </Box>
                    <Box>
                    <Typography sx={{ color: getStatusColor(classe.status), fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{classe.status}</Typography>
                    </Box>
                    </Stack>

                    <Stack direction="row" justifyContent="space-evenly">
       
        

    {classe.status === 'completed' && (
           <>
           <Link to={`/demoevaluation/${classe?.id}`} target="_blank">
          <Button variant="contained" color="secondary">
            View My Evaluation
          </Button>
          </Link>
<Box>
</Box>
</>
        )}
      </Stack>
                   
                    </Stack>

               
            </Grid>
            </Grid>             
            </CardContent>
     </Card>
     </Grid>
                ))}
                </Grid>
                </Box>
        )}

    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" sx={{
      borderRadius: '30px', 
    }}>
      {demoLoading && (
         <Box
         sx={{
           display: 'flex',
           justifyContent: 'center',
           alignItems: 'center',
           height: '100px', // Ensure the box takes up the full height of the dialog
         }}
       >
         <CircularProgress color="primary" />
       </Box>
      )}

      { !demoLoading && data.length == 0 && (
        <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100px',  // Ensure the box takes up the full height of the dialog
        }}
      >
        <Typography
          sx={{
            color: '#019E6F',
            fontFamily: 'Inters',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 600,
          }}
        >
          No data available
        </Typography>
      </Box>
      )}
        {data  && (
          <div>
           
            <DialogContent>
            <Typography sx={{color:'#019E6F' ,fontFamily:'Inters' ,fontSize:'20px' , fontStyle:'normal' , fontWeight:600}}>Demo Details</Typography>
            <IconButton
          edge="end"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      <Box sx={{marginTop:'8px'}}>
        <Divider />
        </Box>

        {data.delivery_mode === 'offline' && (
          <Stack direction='column' spacing={2}>

      <Stack direction='row' justifyContent='space-between'>
            <Box display='flex' >
          <CustomIcon src="/newImages/🦆 icon _Laptop_.svg" alt="School Icon" />
          <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Delivery Mode</Typography>
          </Box>
          <Box>
          <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{data.delivery_mode}</Typography>
          </Box>
          </Stack>
               
          <Stack direction='row' justifyContent='space-between'>
            <Box display='flex' >
          <CustomIcon src="/newImages/🦆 icon _Laptop_.svg" alt="School Icon" />
          <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Room Info</Typography>
          </Box>
          <Box>
          <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{data.room.name}</Typography>
          </Box>
          </Stack>

          <Stack direction='row' justifyContent='space-between'>
            <Box display='flex' >
          <CustomIcon src="/newImages/🦆 icon _Laptop_.svg" alt="School Icon" />
          <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Branch Info</Typography>
          </Box>
          <Box>
          <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{data.branch.branch_name}, {data.branch.address} , {data.branch.branch_pin_code} </Typography>
          </Box>
          </Stack>

          <Stack direction='row' justifyContent='space-between'>
            <Box display='flex' >
          <CustomIcon src="/newImages/🦆 icon _Laptop_.svg" alt="School Icon" />
          <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Location Link</Typography>
          </Box>
          <Box>
          <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>
          <a
      href={data.location_link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'blue', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', textDecoration: 'none', fontWeight: 400 }}
    >
      {data.location_link}
    </a>
             </Typography>
          </Box>
          </Stack>
          </Stack>
        )}

{data.delivery_mode === 'online' && (
          <Stack direction='column' spacing={2}>
               
          <Stack direction='row' justifyContent='space-between'>
            <Box display='flex' >
          <CustomIcon src="/newImages/🦆 icon _Laptop_.svg" alt="School Icon" />
          <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Delivery Mode</Typography>
          </Box>
          <Box>
          <Typography sx={{ color: '#666666', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px'}} fontWeight={400}>{data.delivery_mode}</Typography>
          </Box>
          </Stack>

          <Stack direction='row' justifyContent='space-between'>
            <Box display='flex' >
          <CustomIcon src="/newImages/🦆 icon _Laptop_.svg" alt="School Icon" />
          <Typography sx={{ color: '#000000', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', marginLeft: '5px'}} fontWeight={400}>Zoom Link</Typography>
          </Box>
          <Box>
          <a
      href={data.zoom_link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'blue', fontFamily: '"Inters-Regular", Helvetica', fontSize: '14px', textDecoration: 'none', fontWeight: 400 }}
    >
      {data.zoom_link}
    </a>
          </Box>
          </Stack>
          </Stack>
        )}
             
            </DialogContent>
          </div>
        )}
      </Dialog>

        </div>
        </Box>
        </MainCard>
        </>
      );
  
}

export default StudentViewDemos